import {
  Banned,
  EarthAlert,
  ShieldCheck,
  Warning,
  WarningCircle,
} from '@hhgtech/icons/core'

import { AirPopulationStatus } from 'interfaces/types/AirPopulation'

import { AirPopulationConfigType, ChartSizeType } from './index.types'

export const AIR_POPULATION_CONFIG: {
  [key in AirPopulationStatus]: AirPopulationConfigType
} = {
  [AirPopulationStatus.GOOD]: {
    color: 'green',
    valueColorIndex: 7,
    statusColorIndex: 6,
    borderStartColorIndex: 2,
    borderEndColorIndex: 8,
    informationIcon: ShieldCheck,
  },
  [AirPopulationStatus.MODERATE]: {
    color: 'yellow',
    valueColorIndex: 6,
    statusColorIndex: 5,
    borderStartColorIndex: 2,
    borderEndColorIndex: 6,
    informationIcon: WarningCircle,
  },
  [AirPopulationStatus.UNHEALTHY_FOR_SENSITIVE]: {
    color: 'yellow',
    valueColorIndex: 9,
    statusColorIndex: 9,
    borderStartColorIndex: 5,
    borderEndColorIndex: 9,
    informationIcon: Warning,
  },
  [AirPopulationStatus.UNHEALTHY]: {
    color: 'red',
    valueColorIndex: 7,
    statusColorIndex: 6,
    borderStartColorIndex: 3,
    borderEndColorIndex: 6,
    informationIcon: Warning,
  },
  [AirPopulationStatus.VERY_UNHEALTHY]: {
    color: 'violet',
    valueColorIndex: 8,
    statusColorIndex: 7,
    borderStartColorIndex: 4,
    borderEndColorIndex: 8,
    informationIcon: Banned,
  },
  [AirPopulationStatus.HAZARDOUS]: {
    color: 'redViolet',
    valueColorIndex: 9,
    statusColorIndex: 8,
    borderStartColorIndex: 5,
    borderEndColorIndex: 9,
    informationIcon: EarthAlert,
  },
}

export const CURRENT_LOCATION_KEY = 'currentLocation'
export const CURRENT_LOCATION_LABEL_TRANSLATE_KEY = 'airPopulation.getLocation'
export const CHART_DEMENSION_BY_SIZE: {
  [key in ChartSizeType]: number
} = {
  md: 240,
  sm: 200,
}
